import React from "react";
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Card,
  Typography,
  Image,
  notification,
} from "antd";
import "./Contact.module.css";
import { contactService } from "../services/contactService";
import { errorHandlingService } from "../services/errorHandlingService";
import { ContactDTO } from "../models/Contact";
import { MailFilled, PhoneOutlined } from "@ant-design/icons";
const { Title, Paragraph } = Typography;
const ContactPage: React.FC = () => {
  const [form] = Form.useForm<ContactDTO>();

  const onFinish = async (values: ContactDTO) => {
    try {
      await contactService.sendContact(values);
      form.resetFields();

      notification.success({
        message: "Anagrafica paziente aggiornata con successo",
      });
    } catch (error) {
      errorHandlingService.handleError(error);
    }
  };

  return (
    <div className="contact-page">
      <Row gutter={[16, 16]} justify="center">
        <Col xs={24} md={12}>
          <Card>
            <Title level={2}>Contatti</Title>
            <Paragraph>
              Ambulatorio delle Malattie Rare Cardiovascolari
              <br />
              Piano -1, Torre Cardiologica
              <br />
              Ogni Giovedì dalle 14:00 alle 18:00
              <br />
              Responsabile: Prof. Gennaro Galasso,
              <br />
              UOC Clinica Cardiologica
              <br />
              Direttore: Prof Carmine Vecchione
              <br />
              AOU San Giovanni di Dio e Ruggi d’Aragona di Salerno
              <br />
              Università degli Studi di Salerno, Dipartimento di Medicina,
              Chirurgia e Odontoiatria
              <br />
              Scuola Medica Salernitana
              <br />
              <br />
            </Paragraph>
            <Paragraph>
              Prenota una televisita:
              <br />
              <a
                href="https://www.sangiovannieruggi.it/web/ruggi-salerno/home/-/asset_publisher/yubl/content/televisita"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.sangiovannieruggi.it/web/ruggi-salerno/home/-/asset_publisher/yubl/content/televisita
              </a>
            </Paragraph>
            <Paragraph>
              <PhoneOutlined /> Tel. 089 673273
              <br />
              <MailFilled />{" "}
              <a href="mailto:rarecardiounisa@gmail.com">
                rarecardiounisa@gmail.com
              </a>
              <br />
              Link utili:
              <br />
              <a
                href="https://www.dipmed.unisa.it/"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.dipmed.unisa.it/
              </a>
              <br />
              <a
                href="https://www.sangiovannieruggi.it/web/ruggi-salerno"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.sangiovannieruggi.it/web/ruggi-salerno
              </a>
              <br />
              <a
                href="https://www.orpha.net/it"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.orpha.net/it
              </a>
            </Paragraph>
          </Card>
        </Col>
        <Col xs={24} md={12}>
          <Card>
            <Image
              src="https://via.placeholder.com/400"
              alt="Collaborazione tra medici e specialisti"
              preview={false}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} justify="center">
        <Col xs={24} md={12}>
          <Card>
            <Title level={2}>Invia un messaggio</Title>
            <Form
              name="contact"
              form={form}
              layout="vertical"
              onFinish={onFinish}
            >
              <Form.Item
                name="name"
                label="Nome"
                rules={[
                  {
                    required: true,
                    message: "Per favore inserisci il tuo nome!",
                  },
                ]}
              >
                <Input placeholder="Inserisci il tuo nome" />
              </Form.Item>
              <Form.Item
                name="email"
                label="Email"
                rules={[
                  {
                    required: true,
                    message: "Per favore inserisci la tua email!",
                  },
                  { type: "email", message: "Inserisci una email valida!" },
                ]}
              >
                <Input placeholder="Inserisci la tua email" />
              </Form.Item>
              <Form.Item
                name="message"
                label="Messaggio"
                rules={[
                  {
                    required: true,
                    message: "Per favore inserisci il tuo messaggio!",
                  },
                ]}
              >
                <Input.TextArea
                  rows={4}
                  placeholder="Inserisci il tuo messaggio"
                />
              </Form.Item>
              <Form.Item>
                <Button type="primary" htmlType="submit">
                  Invia
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
        <Col xs={24} md={12}>
          <Card>
            <Title level={2}>Dove ci troviamo</Title>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3111.5453094362227!2d14.78050231549251!3d40.676994179335106!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x133b9f9b08c95389%3A0x7a5629306d99a7e7!2sOspedale%20San%20Giovanni%20di%20Dio%20e%20Ruggi%20d&#39;Aragona!5e0!3m2!1sit!2sit!4v1693000000000!5m2!1sit!2sit"
              width="100%"
              height="350"
              style={{ border: 0 }}
              title="Mappa posizione"
              allowFullScreen={false}
              loading="lazy"
            ></iframe>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default ContactPage;
